import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import FormControl from "@mui/material/FormControl";
import AddCircleSharpIcon from "@mui/icons-material/AddCircleSharp";
import RemoveCircleSharpIcon from "@mui/icons-material/RemoveCircleSharp";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Styles from "../../../../../Slices/Mof/Styles.json";
import axios from 'axios'
import ApiSetting from '../../../../../../Settings/ApiSettings.json'
import Cookies from "universal-cookie";
import Button from "@mui/material/Button";
import swal from "sweetalert";
const cookies = new Cookies();
const language = cookies.get("language") ? cookies.get("language") : "ar";

function ChildredList({getCurrentReportDataAfterUpdate, object ,Access,advanceSearch,section_id,stage_transaction_type_id}) {
    const [childrens,setChildrens]=useState([])
    const [loading,setLoading]=useState(false)


    const checkAccessPrivileges =()=>{
        let check=true;
        Access?.map((data)=>{
            if(data==1){
                check=true;
            }else if(data==2||data==3||data==4){
                check=false
            }
        })
        return check;
    }
    const checkAccessPrivilegesCanAdd=()=>{
        let check=false;
        Access?.map((data)=>{
            if(data==2){
                check=true;
             }
        })
        return check;
    }

    const checkAccessPrivilegesCanEdit=()=>{
        let check=false;
        Access?.map((data)=>{
            if(data==3){
                check=true;
             }
        })
        return check;
    }
    const checkAccessPrivilegesCanDelete=()=>{
        let check=false;
        Access?.map((data)=>{
            if(data==4){
                check=true;
             }
        })
        return check;
    }



    useEffect(()=>{
       if(object?.chilldren_alloweds?.length>0){
         let arr=[];
        object.chilldren_alloweds.map((data) => {
            arr.push({
                id:data?.id,
                boy_or_girl_name: data?.boy_or_girl_name,
                birth_date:data?.birth_date,
                civil_status_card_date: data?.civil_status_card_date,
                civil_status_card_number: data?.civil_status_card_number,
                incom_tax_reports_id: data?.incom_tax_reports_id,
                gender: data?.gender,
                is_married: data?.is_married,
                new:false,

            })
        })
        setChildrens(arr)
       }
    },[object])

    const updatedataOfChildrens=(id,name,value)=>{
        let arr=[]
        childrens?.map((data) => {
            if(data?.id==id){
                console.log('done');
                arr.push({
                    ...data,
                    [name]:value
                })
            }else{
                arr.push(data)
            }
        })
        setChildrens(arr)
    }

    const insertNewChild=()=>{
        setChildrens([...childrens,{
            id:childrens[childrens?.length-1]?.id+1,
            boy_or_girl_name: '',
            birth_date:null,
            civil_status_card_date: null,
            civil_status_card_number: null,
            incom_tax_reports_id: object?.id,
            gender: 0,
            is_married: 0,
            new:true,
        }])
    }
    const removeNewChild=async(id)=>{

        let arr=[]
        childrens?.map((data) => {
            if(data?.id !==id){
                arr.push(data)
            }
        })
        setChildrens(arr)
    }
    const removeChild=async(id)=>{
        let data=null;
        // setLoading(true);
        swal({
            title: "هل  انت متئكد?",
            text: "بمجرد حذفك للعنصر لان يعد بامكانك استرجاعه!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
          })
          .then(async(willDelete) => {
            if (willDelete) {
          
                try{
                    data=await axios({
                    method: 'delete',
                    url:ApiSetting.apiUrl+'/children_allow/'+object?.id,
                    data:{
                        child_id:id,
                    },
                    headers:{
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        "X-localization": language,
                    }
                    })
                    if(data){
                        if(data?.data?.status==200){
                            // swal("تم الحذف!", `${data?.data?.message}`, "success");
                            swal(`${data?.data?.message}`, {
                                icon: "success",
                            });
                            setChildrens(data?.data?.data);
                            advanceSearch()
                        }else{
                            console.log(data?.data?.message);
                            swal("فشل الحذف!", `${data?.data?.message}`, "warning");
            
                        }
                    }
                    setLoading(false);
            
                }catch(err){
                    swal("فشل الحذف!", `${err?.message}`, "error");
                    setLoading(false);
            
                }
        }
      });
        
    }

    //============format date to format yyyy-mm-dd============
    const formatDate = (date) => {
    let y = date.getFullYear();

    let m = date.getMonth() + 1;
    if (m < 10) m = "0" + m;

    let d = date.getDate();
    if (d < 10) d = "0" + d;

    return y + "-" + m + "-" + d;
    };

    const updateData=async()=>{
    let data=null;
    setLoading(true);
    try{
        data=await axios({
           method: 'put',
           url:ApiSetting.apiUrl+'/income_tax_report/'+object?.id,
           data:{
            section_name:'8',
            childrens:childrens,
            user_id:cookies.get('user_id'),
            role_id:cookies.get('role_id')+1,
            section_id:section_id,
            stage_transaction_type_id:stage_transaction_type_id
           },
           headers:{
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            "X-localization": language,
           }
        })
        if(data){
            if(data?.data?.status==200){
                swal("تم التحديث!", `${data?.data?.message}`, "success");
                setChildrens(data?.data?.data);
                advanceSearch()
                getCurrentReportDataAfterUpdate()

            }else{
                console.log(data?.data?.message);
                swal("فشل التحديث!", `${data?.data?.message}`, "warning");

            }
        }
        setLoading(false);

    }catch(err){
        swal("فشل التحديث!", `${err?.message}`, "error");
        setLoading(false);

    }
    
    }


    return (
        <>
            {/*###==>children list ...  */}
            <h4
                style={{
                    marginRight: "10px",
                    color: "#5f7b8a",
                }}
            >
                الاولاد المشمولين بالسماح{" "}
            </h4>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    flexFlow: "row wrap",
                    width: "98%",
                    minWidth: 200,
                    border: "1px solid",
                    borderColor: "#5f7b8a",
                    borderRadius: 10,
                    margin: 10,
                    paddingBottom: 10,
                }}
            >
                {
                    checkAccessPrivilegesCanAdd()?
                        <div
                            style={{
                                display: "flex",
                                width: "100%",
                                minWidth: 200,
                                marginTop: 10,
                                paddingLeft: 10,
                                paddingTop: 10,
                                paddingRight: 10,
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <FormControl fullWidth>
                                <AddCircleSharpIcon
                                    onClick={() => {
                                        insertNewChild()
                                    }}
                                    style={{
                                        fontSize: 40,
                                        // borderRadius: "10px",
                                        // backgroundColor: Styles.Colors.MOF_Modal_BGcolor,
                                        color: Styles.Colors.MOF_Modal_BGcolor,
                                        cursor: "pointer",
                                    }}
                                />
                            </FormControl>

                            <Typography className="fontForError"></Typography>
                        </div>
                    :null
                }

                {childrens?.length > 0
                    ? childrens?.map((data) => (
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                flexFlow: "row wrap",
                                width: "100%",
                                minWidth: 200,
                                // border: "1px solid",
                                borderColor: "#5f7b8a",
                                borderRadius: 10,
                                margin: 10,
                                paddingBottom: 10,
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    width: "20%",
                                    minWidth: 200,
                                    marginTop: 10,
                                    paddingTop: 10,
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <FormControl fullWidth>
                                    <TextField
                                        label="اسم الولد او البنت "
                                        variant="outlined"
                                        InputProps={{
                                            readOnly: checkAccessPrivileges(),
                                        }}
                                        value={data.boy_or_girl_name}
                                        onChange={(e) => {
                                            // setNameOfBoyOrGirl(data, e.target.value);
                                            updatedataOfChildrens(data?.id,'boy_or_girl_name',e.target.value)
                                        }}
                                    />
                                </FormControl>
                                <Typography className="fontForError"></Typography>
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    width: "50%",
                                    minWidth: 200,
                                    marginTop: 10,
                                    paddingLeft: 10,
                                    paddingTop: 10,
                                    paddingRight: 10,
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <FormControl fullWidth>
                                    <InputLabel id="career-simple-select-label">
                                        الجنس
                                    </InputLabel>
                                    <Select
                                        labelId="career-simple-select-label"
                                        id="career-simple-select"
                                        disabled={checkAccessPrivileges()}
                                        value={data.gender}
                                        label="الجنس "
                                        onChange={(e) => {
                                            // setGender(e.target.value);
                                            updatedataOfChildrens(data?.id,'gender',e.target.value)

                                        }}
                                    >
                                        <MenuItem value={0}>{"ذكر"}</MenuItem>
                                        <MenuItem value={1}>{"انثى"}</MenuItem>
                                    </Select>
                                </FormControl>

                                <Typography className="fontForError">
                                    {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.gender) {
                            return err.gender;
                          }
                        })
                      : null} */}
                                </Typography>
                            </div>
                            {data.gender == 1 ?
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        // width: "20%",
                                        flex: 1,
                                        minWidth: 200,
                                        marginTop: 10,
                                        paddingLeft: 10,
                                        paddingTop: 10,
                                        paddingRight: 10,
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <FormControl fullWidth>
                                        <InputLabel id="career-simple-select-label">
                                            الحالة الزوجية
                                        </InputLabel>
                                        <Select
                                           disabled={checkAccessPrivileges()}
                                            labelId="career-simple-select-label"
                                            id="career-simple-select"
                                            value={
                                                data.is_married == 1
                                                    ? "متزوج | متزوجة"
                                                    : "غير متزوج | متزوجة"
                                            }
                                            label="الحالة الزوجية"
                                            onChange={(e) => {
                                                // setCareer(e.target.value);
                                                    if (e.target.value == "متزوج | متزوجة") {
                                                        updatedataOfChildrens(data?.id,'is_married',1)
                                                    } else {
                                                        updatedataOfChildrens(data?.id,'is_married',0)
                                                    }

                                            }}
                                        >
                                            <MenuItem
                                                value={"متزوج | متزوجة"}
                                                key={"متزوج | متزوجة"}
                                            >
                                                {"متزوج | متزوجة"}
                                            </MenuItem>
                                            <MenuItem
                                                value={"غير متزوج | متزوجة"}
                                                key={"غير متزوج | متزوجة"}
                                            >
                                                {"غير متزوج | متزوجة"}
                                            </MenuItem>
                                        </Select>
                                    </FormControl>

                                    <Typography className="fontForError">
                                         {
                                            data?.is_married==1?'هذا الفتات ليس لها سماح':''
                                         }
                                    </Typography>
                                </div> : null
                            }
                            <div
                                style={{
                                    display: "flex",
                                    width: "20%",
                                    minWidth: 200,
                                    marginTop: 10,
                                    paddingTop: 10,
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DesktopDatePicker
                                            label="تاريخ  الولادة"
                                            disabled={checkAccessPrivileges()}
                                            inputFormat="dd/MM/yyyy"
                                            value={(typeof data.birth_date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(data.birth_date)) ? new Date(Number(data.birth_date.slice(0,4)), Number(data.birth_date.slice(5,7))-1, Number(data.birth_date.slice(8,10))) : (data.birth_date instanceof Date ? data.birth_date : null)}
                                            onChange={(birthdate) => {
                                               const val = (birthdate instanceof Date && !isNaN(birthdate.getTime())) ? formatDate(birthdate) : null;
                                               updatedataOfChildrens(data?.id,'birth_date', val);
                                            }}
                                            renderInput={(params) => (
                                                <TextField InputProps={{
                                                    readOnly: true,
                                                }} {...params} />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                                <Typography className="fontForError"></Typography>
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    width: "20%",
                                    minWidth: 200,
                                    marginTop: 10,
                                    paddingTop: 10,
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <FormControl fullWidth>
                                    <TextField
                                        InputProps={{
                                            readOnly: checkAccessPrivileges(),
                                        }}
                                        label="رقم بطاقة الاحوال المدنية"
                                        variant="outlined"
                                        value={data.civil_status_card_number}
                                        onChange={(e) => {
                                            // setCivilStatusCardNumberOfBoyOrGirl(
                                            //   data,
                                            //   e.target.value
                                            // );
                                            updatedataOfChildrens(data?.id,'civil_status_card_number',e.target.value);

                                        }}
                                    />
                                </FormControl>
                                <Typography className="fontForError"></Typography>
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    width: "20%",
                                    minWidth: 200,
                                    marginTop: 10,
                                    paddingTop: 10,
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DesktopDatePicker
                                            disabled={checkAccessPrivileges()}
                                            label="تاريخ بطاقة الاحوال المدنية"
                                            inputFormat="dd/MM/yyyy"
                                            value={(typeof data.civil_status_card_date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(data.civil_status_card_date)) ? new Date(Number(data.civil_status_card_date.slice(0,4)), Number(data.civil_status_card_date.slice(5,7))-1, Number(data.civil_status_card_date.slice(8,10))) : (data.civil_status_card_date instanceof Date ? data.civil_status_card_date : null)}
                                            onChange={(birthdate) => {
                                               const val = (birthdate instanceof Date && !isNaN(birthdate.getTime())) ? formatDate(birthdate) : null;
                                               updatedataOfChildrens(data?.id,'civil_status_card_date', val);
                                            }}
                                            renderInput={(params) => (
                                                <TextField InputProps={{
                                                    readOnly: true,
                                                }} {...params} />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                                <Typography className="fontForError"></Typography>
                            </div>
                           {
                            checkAccessPrivilegesCanDelete()||data?.new?
                            <div
                                style={{
                                    display: "flex",
                                    width: "20%",
                                    minWidth: 200,
                                    marginTop: 10,
                                    paddingLeft: 10,
                                    paddingTop: 10,
                                    paddingRight: 10,
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <FormControl fullWidth>
                                    <RemoveCircleSharpIcon
                                        onClick={() => {
                                            
                                            if(checkAccessPrivilegesCanDelete()&& !data?.new)
                                                removeChild(data?.id)
                                            else  removeNewChild(data?.id);
                                        }}
                                        title={checkAccessPrivilegesCanDelete()&& !data?.new?'بيانت جديدة':''}
                                        style={{
                                            fontSize: 40,
                                            // borderRadius: "10px",
                                            // backgroundColor: Styles.Colors.MOF_Modal_BGcolor,
                                            color: checkAccessPrivilegesCanDelete()&& !data?.new?'red':Styles.Colors.MOF_Modal_BGcolor,
                                            cursor: "pointer",
                                        }}
                                    />
                                </FormControl>

                                <Typography className="fontForError"></Typography>
                            </div>
                            :null
                           }


                        </div>
                    ))
                    : null}
            </div>
            {
                checkAccessPrivilegesCanEdit()||checkAccessPrivilegesCanAdd()?
                <div
                    style={{
                        display: "flex",
                        width:'100%',
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "end",
                        alignItems: "center",
                    }}
                >
                    <Button variant="contained" style={{backgroundColor:"#5f7b8a",paddingLeft:30,paddingRight:30}}
                    onClick={()=>{
                        updateData();
                    }}
                    >
                        {!loading ? (
                        checkAccessPrivilegesCanEdit()? "تحديث":checkAccessPrivilegesCanAdd()?'أضافة':''
                    ) : (
                        <div class="spinner-border " role="status">
                        <span class="visually-hidden">Loading...</span>
                        </div>
                    )}
                    </Button>
                </div>:null
            }
        </>
    )
}

export default ChildredList